import Nav from "../components/Nav";
import Content from "../components/Content";
import SideNav from "../components/SideNav";

function PassageUI() {
  return (
    <>
      <Nav></Nav>
      <div className=" w-full h-full flex pt-16 translate-z-20">
        <SideNav></SideNav>
        <Content></Content>
      </div>
    </>
  );
}

export default PassageUI;
